import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div`
    background: rgba(116, 120, 129, 0.08);
    padding: ${rem(45)} 0;
`;

export const Note = styled.p`
    width: ${rem(650)};
    margin: ${rem(-30)} auto ${rem(30)} auto;
    padding-left: ${rem(25)};
    font-size: ${({ theme }) => theme.fontSizes.textBase};

    @media (min-width: ${breakpoints.sm}px) {
        width: ${rem(800)};
    }
`;

export const TableWrapper = styled.div`
    overflow-x: scroll;
    margin-top: ${rem(15)};

    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Table = styled.table<{ desktopWidth: number; mobileWidth?: number }>`
    border-collapse: separate;
    border-spacing: ${rem(10)} 0;
    width: ${(props) => (props.mobileWidth ? rem(props.mobileWidth) : rem(1000))};
    margin: 0 auto ${rem(45)} auto;

    @media (min-width: ${breakpoints.sm}px) {
        width: ${(props) => (props.desktopWidth ? rem(props.desktopWidth) : rem(1000))};
    }

    tr,
    td {
        height: ${rem(60)};
        margin: 0 ${rem(20)};
        text-align: center;
    }

    th:nth-child(1),
    td:nth-child(1) {
        text-align: left;
        padding: 0 ${rem(15)};
    }

    th:nth-child(1) {
        font-weight: bold;
    }

    th {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};

        span {
            padding: 30px 0;
            display: inline-block;
            width: 80%;
            border-bottom: 1px solid rgba(116, 120, 129, 0.2);

            &.withoutBorder {
                border-bottom: unset;
            }
        }

        .icon {
            padding: 0;
            border: 0;
            margin-top: ${rem(30)};

            svg {
                width: ${rem(50)};
                height: ${rem(50)};
            }
        }
    }

    td {
        font-size: ${({ theme }) => theme.fontSizes.h6};
        color: ${({ theme }) => theme.colors.grey};
        line-height: ${rem(26)};

        :nth-child(1) {
            color: ${({ theme }) => theme.colors.black};
        }
    }

    th:nth-child(2),
    th:nth-child(3),
    th:nth-child(4),
    th:nth-child(5) {
        background: white;
        border-top-left-radius: ${rem(16)};
        border-top-right-radius: ${rem(16)};
    }

    td:nth-child(2),
    td:nth-child(3),
    td:nth-child(4),
    td:nth-child(5) {
        background: white;
    }

    tr:last-child td:nth-child(2),
    tr:last-child td:nth-child(3),
    tr:last-child td:nth-child(4),
    tr:last-child td:nth-child(5) {
        background-color: rgba(116, 120, 129, 0.04);
        border-bottom-left-radius: ${rem(16)};
        border-bottom-right-radius: ${rem(16)};
    }

    tr:nth-child(3) td:nth-child(2),
    tr:nth-child(5) td:nth-child(2) {
        background: rgba(116, 120, 129, 0.05);
    }

    tr:nth-child(3),
    tr:nth-child(5),
    tr:nth-child(7) {
        background-color: rgba(116, 120, 129, 0.04);
    }
`;
